import { Card, Fab, Grid2 as Grid, Typography, Link } from "@mui/material";
import TileLink from "components/shared/TileLink";
import { ReactElement } from "react";
// import logo from "./public/super_fun.jg"

const MainPage = (): ReactElement => {
  const goToInventory = (option: string) => {
    window.location.href = "/articles/category/" + option;
  };

  const goToContactUs = () => {
    window.location.href = "/aboutUs";
  };

  return (
    <>
      <Card>
        <Grid container>
          <Grid size={1} direction={"column"} />
          <Grid size={10} direction={"column"} >
            <img src={'/super_fun.jpg'} alt="super fun logo" style={{ width: '100%' }} />
          </Grid>
          <Grid size={1} direction={"column"} />
        </Grid>
        <Grid container>
          <Grid size={3} direction={"column"} style={{minWidth:200}}>
            <Card>
              <TileLink linkTo="/articles/category/1" footer="RENT ME" imgSrc="https://lirp.cdn-website.com/92a7f81d/dms3rep/multi/opt/1-800h.png" />
            </Card>
          </Grid>
          <Grid size={3} direction={"column"} style={{minWidth:200}}>
            <Card>
              <TileLink linkTo="/articles/category/2" footer="BUY INFLATABLES" imgSrc="https://lirp.cdn-website.com/92a7f81d/dms3rep/multi/opt/2-800h.png" />
            </Card>
          </Grid>
          <Grid size={3} direction={"column"} style={{minWidth:200}}>
            <Card>
              <TileLink linkTo="/articles/category/3" footer="PARTY EQUIPMENT" imgSrc="https://lirp.cdn-website.com/92a7f81d/dms3rep/multi/opt/Bouncing+World+Rentals+%282%29-800h.png" />
            </Card>
          </Grid>
          <Grid size={3} direction={"column"} style={{minWidth:200}}>
            <Card>
              <TileLink linkTo="/contactUs" footer="CONTACT US" imgSrc="https://lirp.cdn-website.com/92a7f81d/dms3rep/multi/opt/4-800h.png" />
            </Card>
          </Grid>
        </Grid>
        <br />
        <Grid container>
          <Grid size={6} direction={"column"} style={{minWidth:360}}>
            <Card >
              <img src='https://lirp.cdn-website.com/92a7f81d/dms3rep/multi/opt/iStock-1434963922-1920w.jpg' alt="rent" style={{ width: '100%' }} />
            </Card>
          </Grid>
          <Grid size={6} direction={"column"} style={{minWidth:360}}>
            <Card>
              <Typography variant="h4" color="blue">RENT THE LIFE OF THE PARTY!</Typography>
              <Typography>Take your party or event to the next level with our high-quality inflatables and bouncing houses! Whether you're celebrating a birthday, block party, or just want a bouncing good time, we have the experience to help make your event unforgettable. Bouncing World Rentals offers full day rentals, as well as a wide range of inflatables to choose from. We also set up and tear down for you so that the entire process is stress free. One day rentals typically begin and are dropped off before noon on the day of your event and are picked up by noon the following day. We also offer hourly rentals. Contact us today to get your inflatable booked today!</Typography>
            </Card>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size={6} direction={"column"} style={{minWidth:360}}>
            <Card>
              <Typography variant="h4" color="blue">RENTALS FOR ANY EVENT!</Typography>
              <Typography>Bouncing Houses, inflatables, and party equipment rentals aren't just for birthday parties! Some common event rentals booked for are:
                Picnics
                Weddings
                Festivals
                Holiday Parties
                Birthday Parties
                Firework Stands
                Grand Openings
                Neighborhood/Community Parties
                Family Reunions
                Inflatable rentals add memorable experiences to any event in Northwest Arkansas. Contact us for any questions!</Typography>
            </Card>
          </Grid>
          <Grid size={6} direction={"column"} style={{minWidth:360}}>
            <Card>
              <img src='https://lirp.cdn-website.com/92a7f81d/dms3rep/multi/opt/iStock-153642010-1920w.jpg
' alt="events" style={{ width: '100%' }} />
            </Card>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size={9} direction={"column"} style={{minWidth:380}}>
            <Card>
              <Typography variant="h4" color="blue">Inflatable Rentals for Northwest Arkansas and Beyond!</Typography>
              <Typography>Our dream of bringing family entertainment and memorable experiences to our area. Ana has had over 5 years of experience in the inflatables industry which has given her special insight on creating unforgettable events. Together, Ana and Oscar enjoy exploring Northwest Arkansas with their children in their spare time. Call today to get your inflatable booked for your next party or event!</Typography>
            </Card>
          </Grid>
          <Grid size={3} direction={"column"} style={{minWidth:360}}>
            <Card>
              <iframe src="https://www.facebook.com/plugins/video.php?height=476&amp;href=https%3A%2F%2Fwww.facebook.com%2Fbouncingworldrentalsllc%2Fvideos%2F367099262822070%2F&amp;show_text=false&amp;width=267&amp;t=0" width="267" height="476" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            </Card>
          </Grid>
          <Grid container>
            <Grid size={12} direction={"column"}>
              <Card>
                <></>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <div style={{
        //backgroundAttachment:'scroll',
        // margin:'auto',
        position: 'sticky',
        // position: '-webkit-sticky',
        bottom: 80,
        float: 'right',
        display: 'inline-block',
        textAlign: 'right'
      }}>
        <Link href={"/articles/category/1"}>
          <Fab variant="extended" color="primary">
            Reserve your inflateble today!
          </Fab>
        </Link>
        <br /><br />
        <Link href={"/articles/category/3"}>
          <Fab variant="extended" color="inherit">
            Party Equipment
          </Fab>
        </Link>
      </div>
    </>
  );
};

export default MainPage;
